import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { POST_URL } from '@utils/api/endpoints.ts';
import { UserPreferenceDto } from '@utils/types/user-preferences/user-preferences.ts';

const postExportTemplate = (payload: UserPreferenceDto) =>
  Axios.post<unknown>(POST_URL().userPreferences, payload).then(
    res => res.data
  );

export const useAddPreference = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, AxiosError<BaseError>, UserPreferenceDto>(
    postExportTemplate,
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['userPreferences']);
      },
      useErrorBoundary: false
    }
  );
};
